import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'career-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  isCareerPageActive = false;

  ngOnInit() {
    const currentPath = window.location.pathname;
    this.isCareerPageActive = currentPath === '/' || currentPath === '/karrier';
  }
}
